import { render, staticRenderFns } from "./TheFamilyHistoryFeedbackForm.vue?vue&type=template&id=e9276d9a&scoped=true&"
import script from "./TheFamilyHistoryFeedbackForm.vue?vue&type=script&lang=js&"
export * from "./TheFamilyHistoryFeedbackForm.vue?vue&type=script&lang=js&"
import style0 from "./TheFamilyHistoryFeedbackForm.vue?vue&type=style&index=0&id=e9276d9a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9276d9a",
  null
  
)

export default component.exports